var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDate = function SvgDate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_calendar"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "shape",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "shape",
    transform: "translate(1.333333, 0.666667)",
    fill: "#777776",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,2.66666667 C1.63181017,2.66666667 1.33333333,2.9651435 1.33333333,3.33333333 L1.33333333,12.6666667 C1.33333333,13.0348565 1.63181017,13.3333333 2,13.3333333 L11.3333333,13.3333333 C11.7015232,13.3333333 12,13.0348565 12,12.6666667 L12,3.33333333 C12,2.9651435 11.7015232,2.66666667 11.3333333,2.66666667 L2,2.66666667 Z M2,1.33333333 L11.3333333,1.33333333 C12.4379028,1.33333333 13.3333333,2.22876383 13.3333333,3.33333333 L13.3333333,12.6666667 C13.3333333,13.7712362 12.4379028,14.6666667 11.3333333,14.6666667 L2,14.6666667 C0.8954305,14.6666667 0,13.7712362 0,12.6666667 L0,3.33333333 C0,2.22876383 0.8954305,1.33333333 2,1.33333333 Z",
    id: "Rectangle-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666666667,6.66666667 C0.298476833,6.66666667 0,6.36818983 0,6 C0,5.63181017 0.298476833,5.33333333 0.666666667,5.33333333 L12.6666667,5.33333333 C13.0348565,5.33333333 13.3333333,5.63181017 13.3333333,6 C13.3333333,6.36818983 13.0348565,6.66666667 12.6666667,6.66666667 L0.666666667,6.66666667 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66666667,0.666666667 C8.66666667,0.298476833 8.9651435,0 9.33333333,0 C9.70152317,0 10,0.298476833 10,0.666666667 L10,3.33333333 C10,3.70152317 9.70152317,4 9.33333333,4 C8.9651435,4 8.66666667,3.70152317 8.66666667,3.33333333 L8.66666667,0.666666667 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333333,0.666666667 C3.33333333,0.298476833 3.63181017,0 4,0 C4.36818983,0 4.66666667,0.298476833 4.66666667,0.666666667 L4.66666667,3.33333333 C4.66666667,3.70152317 4.36818983,4 4,4 C3.63181017,4 3.33333333,3.70152317 3.33333333,3.33333333 L3.33333333,0.666666667 Z",
    id: "Shape"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/date.44131c57.svg";
export { ForwardRef as ReactComponent };